import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
const call_customer_historyaApi = factory.get("call_customer_history");

const initialState = {
  data: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      customer_name: null,
      user_id: null,
      customer_id: null,
      start_date: null,
      end_date: null,
      mobile: null,
      city_id: null,
      type: null,
      channel: null,
    },
    dialog: false,
  },
  customers: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      subscription_status: "near",
      re_attempt: false,
      city_id: null,
      is_active: null,
      status_start_date: null,
      status_end_date: null,
    },
    dialog: false,
  },
  formModal: {
    dialog: false,
    loading: false,
    form: {
      id: null,
      customer_id: null,
      note: "",
      call_result_id: null,
      call_record_url: "",
      call_record_duration: "",
      call_record_date: "",
      call_record: null,
    },
  },
  customerHistoriesModal: {
    dialog: false,
    customer: null,
    histories: [],
  },
  selectedCustomerDetail: {
    data: null,
    loading: false,
  },
  lockLoading: false,
  tasks: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      start_date: null,
      end_date: null,
      type: "maintenance",
    },
    dialog: false,
  },
  calls: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      start_date: null,
      end_date: null,
      is_success: null,
    },
    dialog: false,
  },
  users: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      take: 25,
      page: 0,
      search: "",
      start_date: null,
      end_date: null,
      is_online: 1,
    },
    dialog: false,
  },
  employeeStatus: {
    data: {
      call_results: [],
      tasks: [],
    },
    loading: false,
    filters: {
      start_date: dayjs().format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
      user_id: null,
    },
  },
};

const callCustomerHistorySlice = createSlice({
  name: "callCustomerHistory",
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      state.data.data = payload.data;
      state.data.total = payload.total;
      state.data.loading = false;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.data.filters = {
        ...state.data.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.data.filters = initialState.data.filters;
    },
    setFiltersDialog: (state, { payload }) => {
      state.data.dialog = !state.data.dialog;
    },
    setCustomersData: (state, { payload }) => {
      state.customers.data = payload.data || [];
      state.customers.total = payload.total || 0;
      state.customers.loading = false;

      if (state.customerHistoriesModal.dialog && state.customerHistoriesModal.customer) {
        const found = (payload.data || []).find(
          (c) => c.id === state.customerHistoriesModal.customer.id
        );
        if (found) {
          state.customerHistoriesModal.histories = found.call_customer_histories || [];
          state.customerHistoriesModal.customer = {
            id: found.id,
            full_name: found.full_name,
            mobile: found.mobile,
          };
        }
      }
    },
    setCustomersLoading: (state, { payload }) => {
      state.customers.loading =
        payload !== undefined ? payload : !state.customers.loading;
    },
    setCustomersFilters: (state, { payload }) => {
      state.customers.filters = {
        ...state.customers.filters,
        ...payload,
      };
    },
    resetCustomersFilters: (state) => {
      state.customers.filters = initialState.customers.filters;
    },
    setCustomersFiltersDialog: (state) => {
      state.customers.dialog = !state.customers.dialog;
    },
    setDialog: (state, { payload }) => {
      state.formModal.dialog = !state.formModal.dialog;
      if (payload) {
        state.formModal.form = {
          id: payload.id || null,
          customer_id: payload.customer_id
            ? {
              id: payload.customer_id,
              full_name: payload.customer_name || "",
              mobile: payload.mobile || "",
            }
            : null,
          note: payload.note || "",
          call_result_id: payload.call_result_id
            ? typeof payload.call_result_id === "object"
              ? payload.call_result_id
              : {
                id: payload.call_result_id,
                name: payload.call_result_name || "",
              }
            : null,
          call_record_url: payload.call_record_url || "",
          call_record_duration: payload.call_record_duration || "",
          call_record_date: payload.call_record_date || "",
          call_record: payload.call_record_url || payload.call_record_duration
            ? {
              cdr: payload.call_record_id || "",
              caller: payload.caller || "",
              callee: payload.callee || "",
              duration: payload.call_record_duration || "",
              start: payload.call_record_date || "",
              url: payload.call_record_url || "",
            }
            : null,
        };
      } else {
        state.formModal.form = initialState.formModal.form;
      }
    },
    setFormModalLoading: (state, { payload }) => {
      state.formModal.loading =
        payload !== undefined ? payload : !state.formModal.loading;
    },
    setCustomerHistoriesDialog: (state, { payload }) => {
      state.customerHistoriesModal.dialog =
        !state.customerHistoriesModal.dialog;
      if (payload) {
        state.customerHistoriesModal.customer =
          payload.customer || payload || null;
        state.customerHistoriesModal.histories =
          payload.histories ||
          payload.call_customer_histories ||
          [];
      } else {
        state.customerHistoriesModal.customer = null;
        state.customerHistoriesModal.histories = [];
      }
    },
    setSelectedCustomerDetail: (state, { payload }) => {
      state.selectedCustomerDetail.data = payload;
      state.selectedCustomerDetail.loading = false;
      if (payload?.id && state.customers.data?.length > 0) {
        const idx = state.customers.data.findIndex((c) => c.id === payload.id);
        if (idx !== -1) {
          state.customers.data[idx] = {
            ...state.customers.data[idx],
            locked_by_id: payload.locked_by_id,
            locked_by_name: payload.locked_by_name,
            locked_at: payload.locked_at,
          };
        }
      }
    },
    setSelectedCustomerLoading: (state, { payload }) => {
      state.selectedCustomerDetail.loading =
        payload !== undefined ? payload : !state.selectedCustomerDetail.loading;
    },
    setLockLoading: (state, { payload }) => {
      state.lockLoading = payload !== undefined ? payload : !state.lockLoading;
    },
    updateCustomerLockStatus: (state, { payload }) => {
      if (state.selectedCustomerDetail.data?.id === payload.id) {
        state.selectedCustomerDetail.data = {
          ...state.selectedCustomerDetail.data,
          locked_by_id: payload.locked_by_id,
          locked_by_name: payload.locked_by_name,
          locked_at: payload.locked_at,
        };
      }
      if (payload?.id && state.customers.data?.length > 0) {
        const idx = state.customers.data.findIndex((c) => c.id === payload.id);
        if (idx !== -1) {
          state.customers.data[idx] = {
            ...state.customers.data[idx],
            locked_by_id: payload.locked_by_id,
            locked_by_name: payload.locked_by_name,
            locked_at: payload.locked_at,
          };
        }
      }
    },
    setTasksData: (state, { payload }) => {
      state.tasks.data = payload.data || [];
      state.tasks.total = payload.total || 0;
      state.tasks.loading = false;
    },
    setTasksLoading: (state, { payload }) => {
      state.tasks.loading =
        payload !== undefined ? payload : !state.tasks.loading;
    },
    setTasksFilters: (state, { payload }) => {
      state.tasks.filters = {
        ...state.tasks.filters,
        ...payload,
      };
    },
    resetTasksFilters: (state) => {
      state.tasks.filters = initialState.tasks.filters;
    },
    setTasksDialog: (state, { payload }) => {
      state.tasks.dialog =
        payload !== undefined ? payload : !state.tasks.dialog;
      if (!state.tasks.dialog) {
        state.tasks.data = [];
        state.tasks.total = 0;
      }
    },
    setCallsData: (state, { payload }) => {
      state.calls.data = payload.data || [];
      state.calls.total = payload.total || 0;
      state.calls.loading = false;
    },
    setCallsLoading: (state, { payload }) => {
      state.calls.loading =
        payload !== undefined ? payload : !state.calls.loading;
    },
    setCallsFilters: (state, { payload }) => {
      state.calls.filters = {
        ...state.calls.filters,
        ...payload,
      };
    },
    resetCallsFilters: (state) => {
      state.calls.filters = initialState.calls.filters;
    },
    setCallsDialog: (state, { payload }) => {
      state.calls.dialog =
        payload !== undefined ? payload : !state.calls.dialog;
    },
    setUsersData: (state, { payload }) => {
      state.users.data = payload.data || [];
      state.users.total = payload.total || 0;
      state.users.loading = false;
    },
    setUsersLoading: (state, { payload }) => {
      state.users.loading =
        payload !== undefined ? payload : !state.users.loading;
    },
    setUsersFilters: (state, { payload }) => {
      state.users.filters = {
        ...state.users.filters,
        ...payload,
      };
    },
    resetUsersFilters: (state) => {
      state.users.filters = initialState.users.filters;
    },
    setUsersDialog: (state, { payload }) => {
      state.users.dialog =
        payload !== undefined ? payload : !state.users.dialog;
    },
    setEmployeeStatusData: (state, { payload }) => {
      state.employeeStatus.data = {
        call_results: Array.isArray(payload?.call_results) ? payload.call_results : [],
        tasks: Array.isArray(payload?.tasks) ? payload.tasks : [],
      };
      state.employeeStatus.loading = false;
    },
    setEmployeeStatusLoading: (state, { payload }) => {
      state.employeeStatus.loading =
        payload !== undefined ? payload : !state.employeeStatus.loading;
    },
    setEmployeeStatusFilters: (state, { payload }) => {
      state.employeeStatus.filters = {
        ...state.employeeStatus.filters,
        ...payload,
      };
    },
    resetEmployeeStatusFilters: (state) => {
      state.employeeStatus.filters = {
        start_date: dayjs().format("YYYY-MM-DD"),
        end_date: dayjs().format("YYYY-MM-DD"),
        user_id: null,
      };
    },
  },
});

export const {
  setData,
  setLoading,
  setFilters,
  resetFilters,
  setFiltersDialog,
  setCustomersData,
  setCustomersLoading,
  setCustomersFilters,
  resetCustomersFilters,
  setCustomersFiltersDialog,
  setCustomerHistoriesDialog,
  setDialog,
  setFormModalLoading,
  setSelectedCustomerDetail,
  setSelectedCustomerLoading,
  setLockLoading,
  updateCustomerLockStatus,
  setTasksData,
  setTasksLoading,
  setTasksFilters,
  resetTasksFilters,
  setTasksDialog,
  setCallsData,
  setCallsLoading,
  setCallsFilters,
  resetCallsFilters,
  setCallsDialog,
  setUsersData,
  setUsersLoading,
  setUsersFilters,
  resetUsersFilters,
  setUsersDialog,
  setEmployeeStatusData,
  setEmployeeStatusLoading,
  setEmployeeStatusFilters,
  resetEmployeeStatusFilters,
} = callCustomerHistorySlice.actions;

export default callCustomerHistorySlice.reducer;

//axios
export const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().callCustomerHistory.data.filters;
    const _filters = {
      ...filters,
      user_id: filters.user_id ? filters.user_id.id : null,
      customer_id: filters.customer_id ? filters.customer_id.id : null,
      city_id: filters.city_id ? filters.city_id.id : null,
    };
    dispatch(setLoading("data"));
    const res = await call_customer_historyaApi.index(_filters);
    dispatch(setData(res.data));
  } catch (err) {
    dispatch(setLoading("data"));
    throw new Error(err);
  }
};
const toExcel = () => async (dispatch, getState) => {
  try {
    const filters = getState().callCustomerHistory.data.filters;
    const _filters = {
      ...filters,
      user_id: filters.user_id ? filters.user_id.id : null,
      customer_id: filters.customer_id ? filters.customer_id.id : null,
      city_id: filters.city_id ? filters.city_id.id : null,
    };
    dispatch(setLoading("data"));
    const res = await call_customer_historyaApi.exportToExcel({
      ..._filters,
      is_excel: 1,
    });
    let url = window.URL.createObjectURL(res.data);
    let a = document.createElement("a");
    a.href = url;
    a.download = "call_customer_history.xlsx";
    a.click();
    dispatch(setLoading("data"));
  } catch (err) {
    dispatch(setLoading("data"));
    throw new Error(err);
  }
};

export const getCustomers = () => async (dispatch, getState) => {
  try {
    const filters = getState().callCustomerHistory.customers.filters;
    const _filters = {
      ...filters,
      city_id: filters.city_id ? filters.city_id.id : null,
      subscription_status: filters.re_attempt
        ? null
        : filters.subscription_status === "all" || !filters.subscription_status
          ? null
          : filters.subscription_status,
      re_attempt: filters.re_attempt ? true : null,
    };
    dispatch(setCustomersLoading(true));
    const res = await call_customer_historyaApi.getCustomers(_filters);
    dispatch(setCustomersData(res.data));
  } catch (err) {
    dispatch(setCustomersLoading(false));
    throw new Error(err);
  }
};

export const create = (data, options = {}) => async (dispatch, getState) => {
  try {
    dispatch(setFormModalLoading(true));
    const payload = {
      customer_id: data.customer_id?.id || data.customer_id,
      note: data.note || null,
      call_result_id: data.call_result_id?.id || data.call_result_id || null,
      call_record_url: data.call_record_url || null,
      call_record_duration: data.call_record_duration || null,
      call_record_date: data.call_record_date || null,
    };
    await call_customer_historyaApi.create(payload);
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: "تم إضافة السجل بنجاح",
        type: "success",
      })
    );
    if (getState().callCustomerHistory.formModal.dialog) {
      dispatch(setDialog());
    }
    dispatch(index());
    await dispatch(getCustomers());
    if (options?.onSuccess) {
      options.onSuccess();
    }
  } catch (err) {
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] || "حدث خطأ أثناء الإضافة",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const update = (data, options = {}) => async (dispatch, getState) => {
  try {
    dispatch(setFormModalLoading(true));
    const payload = {
      customer_id: data.customer_id?.id || data.customer_id,
      note: data.note || null,
      call_result_id: data.call_result_id?.id || data.call_result_id || null,
      call_record_url: data.call_record_url || null,
      call_record_duration: data.call_record_duration || null,
      call_record_date: data.call_record_date || null,
    };
    await call_customer_historyaApi.update(data.id, payload);
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: "تم تعديل السجل بنجاح",
        type: "success",
      })
    );
    if (getState().callCustomerHistory.formModal.dialog) {
      dispatch(setDialog());
    }
    dispatch(index());
    await dispatch(getCustomers());
    if (options?.onSuccess) {
      options.onSuccess();
    }
  } catch (err) {
    dispatch(setFormModalLoading(false));
    dispatch(
      showNotification({
        message: err.response?.data?.errors?.[0] || "حدث خطأ أثناء التعديل",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const reAttempt = (customer_id, options = {}) => async (dispatch) => {
  try {
    const res = await call_customer_historyaApi.reAttempt({ customer_id });
    const successMsg =
      res.data?.message ||
      (options?.isRemove
        ? "تمت إزالة المشترك من قائمة معاودة الاتصال بنجاح"
        : "تمت إضافة المشترك إلى قائمة معاودة الاتصال بنجاح");
    dispatch(
      showNotification({
        message: successMsg,
        type: "success",
      })
    );
    await dispatch(getCustomers());
    if (options?.onSuccess) {
      options.onSuccess(res);
    }
    return res;
  } catch (err) {
    dispatch(
      showNotification({
        message:
          err.response?.data?.errors?.[0] ||
          err.response?.data?.message ||
          "حدث خطأ أثناء تعديل حالة معاودة الاتصال",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const getCustomerById = (customer_id) => async (dispatch) => {
  if (!customer_id) return;
  try {
    dispatch(setSelectedCustomerLoading(true));
    const res = await call_customer_historyaApi.getCustomerById(customer_id);
    const data = res.data?.data || res.data || null;
    dispatch(setSelectedCustomerDetail(data));
    return data;
  } catch (err) {
    dispatch(setSelectedCustomerLoading(false));
    console.error("Error fetching customer by id:", err);
  }
};

export const lockCustomer = (customer_id, options = {}) => async (dispatch, getState) => {
  if (!customer_id) return;
  try {
    dispatch(setLockLoading(true));
    const res = await call_customer_historyaApi.lock(customer_id);
    const data = res.data?.data || res.data || {};
    const currentUser = getState().profile?.user?.info;

    const lockPayload = {
      id: customer_id,
      locked_by_id: data.locked_by_id || currentUser?.id || null,
      locked_by_name:
        data.locked_by_name ||
        currentUser?.full_name ||
        currentUser?.first_name ||
        "أنت",
      locked_at: data.locked_at || new Date().toISOString(),
    };

    dispatch(updateCustomerLockStatus(lockPayload));
    dispatch(setLockLoading(false));

    if (options?.onSuccess) {
      options.onSuccess(data);
    }
    return data;
  } catch (err) {
    dispatch(setLockLoading(false));
    // Refetch customer details to get fresh lock status from backend
    dispatch(getCustomerById(customer_id));

    const errMsg =
      err.response?.data?.errors?.[0] ||
      err.response?.data?.message ||
      "تعذر حجز المشترك";

    dispatch(
      showNotification({
        message: errMsg,
        type: "error",
      })
    );
    throw err;
  }
};

export const getTasks = (customFilters) => async (dispatch, getState) => {
  try {
    const filters = {
      ...getState().callCustomerHistory.tasks.filters,
      ...customFilters,
    };
    const params = {
      skip: filters.skip ?? 0,
      take: filters.take ?? 25,
      start_date: filters.start_date,
      end_date: filters.end_date,
      type: filters.type,
    };
    dispatch(setTasksLoading(true));
    const res = await call_customer_historyaApi.getTasks(params);
    const result = res?.data;

    let data = [];
    let total = 0;
    if (Array.isArray(result)) {
      data = result;
      total = result.length;
    } else if (result && Array.isArray(result.data)) {
      data = result.data;
      total = result.total ?? result.count ?? result.data.length;
    } else if (result && Array.isArray(result.rows)) {
      data = result.rows;
      total = result.count ?? result.rows.length;
    } else if (result && Array.isArray(result.tasks)) {
      data = result.tasks;
      total = result.count ?? result.total ?? result.tasks.length;
    }

    dispatch(setTasksData({ data, total }));
  } catch (err) {
    dispatch(setTasksLoading(false));
    console.error("Error fetching tasks:", err);
    throw new Error(err);
  }
};

export const getCalls = (customFilters) => async (dispatch, getState) => {
  try {
    const filters = {
      ...getState().callCustomerHistory.calls.filters,
      ...customFilters,
    };
    const params = {
      skip: filters.skip ?? 0,
      take: filters.take ?? 25,
      start_date: filters.start_date,
      end_date: filters.end_date,
      is_success: filters.is_success !== undefined ? filters.is_success : null,
    };
    dispatch(setCallsLoading(true));
    const res = await call_customer_historyaApi.getCalls(params);
    const result = res?.data;

    let data = [];
    let total = 0;
    if (Array.isArray(result)) {
      data = result;
      total = result.length;
    } else if (result && Array.isArray(result.data)) {
      data = result.data;
      total = result.total ?? result.count ?? result.data.length;
    } else if (result && Array.isArray(result.rows)) {
      data = result.rows;
      total = result.count ?? result.rows.length;
    } else if (result && Array.isArray(result.calls)) {
      data = result.calls;
      total = result.count ?? result.total ?? result.calls.length;
    }

    dispatch(setCallsData({ data, total }));
  } catch (err) {
    dispatch(setCallsLoading(false));
    console.error("Error fetching calls:", err);
    throw new Error(err);
  }
};

export const getUsers = (customFilters) => async (dispatch, getState) => {
  try {
    const filters = {
      ...getState().callCustomerHistory.users.filters,
      ...customFilters,
    };
    const params = {
      skip: filters.skip ?? 0,
      take: filters.take ?? 25,
      start_date: filters.start_date,
      end_date: filters.end_date,
      is_online: filters.is_online !== undefined ? filters.is_online : null,
    };
    dispatch(setUsersLoading(true));
    const res = await call_customer_historyaApi.getUsers(params);
    const result = res?.data;

    let data = [];
    let total = 0;
    if (Array.isArray(result)) {
      data = result;
      total = result.length;
    } else if (result && Array.isArray(result.data)) {
      data = result.data;
      total = result.total ?? result.count ?? result.data.length;
    } else if (result && Array.isArray(result.rows)) {
      data = result.rows;
      total = result.count ?? result.rows.length;
    } else if (result && Array.isArray(result.users)) {
      data = result.users;
      total = result.count ?? result.total ?? result.users.length;
    }

    dispatch(setUsersData({ data, total }));
  } catch (err) {
    dispatch(setUsersLoading(false));
    console.error("Error fetching users:", err);
    throw new Error(err);
  }
};

export const getEmployeeStatus = (customFilters) => async (dispatch, getState) => {
  try {
    const filters = {
      ...getState().callCustomerHistory.employeeStatus.filters,
      ...customFilters,
    };
    const params = {
      start_date: filters.start_date,
      end_date: filters.end_date,
    };
    if (filters.user_id) {
      params.user_id = typeof filters.user_id === "object" ? filters.user_id.id : filters.user_id;
    }
    dispatch(setEmployeeStatusLoading(true));
    const res = await call_customer_historyaApi.getEmployeeStatus(params);
    const result = res?.data?.data || res?.data || {};
    dispatch(setEmployeeStatusData(result));
    return result;
  } catch (err) {
    dispatch(setEmployeeStatusLoading(false));
    console.error("Error fetching employee status:", err);
  }
};

export const CallCustomerHistory = {
  index,
  toExcel,
  getCustomers,
  create,
  update,
  reAttempt,
  getCustomerById,
  lockCustomer,
  getTasks,
  getCalls,
  getUsers,
  getEmployeeStatus,
};
